(function(angular, module) {var dybHelpIcon;

dybHelpIcon = function() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'forms/helpIcon',
    transclude: true,
    scope: {
      helpText: '='
    },
    link: function(scope, element, attrs, ctrl, translude) {
      scope.hasTransclude = false;
      return translude(function(tElement, tScope) {
        return Object.defineProperty(scope, 'hasTransclude', {
          get: function() {
            return (tElement != null ? tElement.length : void 0) > 0 && tElement.text();
          },
          configurable: true
        });
      });
    }
  };
};

module.directive('dybHelpIcon', dybHelpIcon);
})(angular, angular.module("dybForms"));